import { Spacing, Heading } from '@big-red-group/storefront-common-ui'
import { Container, Image, List, Tile, Wrapper } from './Sustainability.styles'

const Sustainability = () => {
  return (
    <>
      <Wrapper>
        <Heading size="L">Sustainability</Heading>
        <Tile>
          {/* TODO fixed image */}
          {/* eslint-disable-next-line jsx-a11y/alt-text */}
          <Image
            style={{
              backgroundImage: `url(https://cdn.experienceoz.com.au/assets/imgproxy/catalogueType/2/miscGraph/152306.png?format=webp)`,
            }}
          ></Image>
          <Container>
            <div>
              <Heading size="S">Our Promise</Heading>
              <List>
                <li>We are committed to sustainability</li>
                <li>We have an approved Science Based Target</li>
                <li>We use third party verified standards</li>
              </List>
            </div>
          </Container>
        </Tile>
      </Wrapper>
      <Spacing size="XXXL" />
    </>
  )
}

export default Sustainability
